module.exports = "https://static.zego.com/_next/static/images/Three-f1767afb3b4e2f74637594bab68c3373.svg";